import { __assign } from "tslib";
import LAYOUTS from '../../common/constants/layout';
import { calcTargetItemSize } from '../helpers/layoutHelper';

var fixToEmpty = function fixToEmpty(options) {
  var presetOptions = __assign({}, options);

  presetOptions.galleryLayout = LAYOUTS.EMPTY;
  return presetOptions;
};

export var fixedOptions = fixToEmpty({});
export var createOptions = function createOptions(options) {
  var res = __assign({}, options);

  res = fixToEmpty(res);
  res.targetItemSize = calcTargetItemSize(res, Math.round(res.gallerySize * 9 + 100));
  return res;
};